<form [formGroup]="form" class="style-form-default">
	<div class="style-input-default" data-text="Origen de la solicitud *" [ngClass]="{error: verificateInput('origen_solicitud')}">
		<input type="text" placeholder="Origen de la solicitud" formControlName="origen_solicitud">
	</div>
	<div class="style-input-default" data-text="Fecha de la solicitud *" [ngClass]="{error: verificateInput('fecha_solicitud')}">
		<input type="date" formControlName="fecha_solicitud">
	</div>
	<div class="checkboxs column-complete">
		<label class="checkbox" for="acta_analisis">
			<span>Acta de análisis</span>
			<input type="checkbox" id="acta_analisis" formControlName="acta_analisis">
			<i class="fas fa-{{ form.value.acta_analisis ? 'check-square' : 'square' }}"></i>
		</label>
		<label class="checkbox" for="denuncia_policial">
			<span>Denuncia policial</span>
			<input type="checkbox" id="denuncia_policial" formControlName="denuncia_policial">
			<i class="fas fa-{{ form.value.denuncia_policial ? 'check-square' : 'square' }}"></i>
		</label>
		<label class="checkbox" for="carta_reclamo_cliente">
			<span>Carta de reclamo del cliente</span>
			<input type="checkbox" id="carta_reclamo_cliente" formControlName="carta_reclamo_cliente">
			<i class="fas fa-{{ form.value.carta_reclamo_cliente ? 'check-square' : 'square' }}"></i>
		</label>
	</div>
</form>
